






import {
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
} from "@nuxtjs/composition-api";

export default defineComponent({
  name: "LoadWhenVisible",
  props: {
    options: {
      type: Object,
      default: () => ({
        rootMargin: "0px 0px 200px 0px",
        threshold: 0,
      }),
    },
  },
  setup({ options }) {
    const isVisible = ref(false);
    const root = ref<HTMLElement | null>(null);

    const observer = ref<IntersectionObserver | null>(null);

    onMounted(() => {
      if (!process.client || !("IntersectionObserver" in window) || !root.value)
        return;

      observer.value = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isVisible.value = true;
            observer.value?.unobserve(root.value as HTMLElement);
            observer.value = null;
          }
        });
      }, options);

      observer.value.observe(root.value);
    });

    onUnmounted(() => {
      if (observer.value && root.value) {
        observer.value.unobserve(root.value);
        observer.value = null;
      }
    });

    return {
      root,
      isVisible,
    };
  },
});
